import React from "react";
import Form from "app/components/common/Form";
import Input from "app/components/common/Input";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";

function SalonArtistForm(props) {
  const { values, setFieldValue, handleBlur } = props;

  const handlePostalCodeChange = (newValue) => {
    setFieldValue("postalCode", newValue);
  };

  return (
    <div className="space-y-2">
      <Form.Row>
        <Form.Col>店舗名</Form.Col>
        <Form.ColGrow>
          <Input.Field
            name="name"
            type="text"
            className="w-full"
            value={values.name}
            setValue={(newValue) => {
              setFieldValue("name", newValue);
            }}></Input.Field>
        </Form.ColGrow>
      </Form.Row>
      <Form.Row>
        <Form.Col>店舗名（フリガナ）</Form.Col>
        <Form.ColGrow>
          <Input.Field
            name="nameKana"
            type="text"
            className="w-full"
            value={values.nameKana}
            setValue={(newValue) => {
              setFieldValue("nameKana", newValue);
            }}></Input.Field>
        </Form.ColGrow>
      </Form.Row>
      <Form.Row>
        <Form.Col>代表者</Form.Col>
        <Form.ColGrow>
          <Form.Row className="space-x-2">
            <Form.Col className="basis-1 pr-2">姓</Form.Col>
            <Form.ColGrow>
              <Input.Field
                name="picLastName"
                type="text"
                className="w-full"
                value={values.picLastName}
                setValue={(newValue) => {
                  setFieldValue("picLastName", newValue);
                }}></Input.Field>
            </Form.ColGrow>
            <Form.Col className="basis-1 pr-2">名</Form.Col>
            <Form.ColGrow>
              <Input.Field
                name="picFirstName"
                type="text"
                className="w-full"
                value={values.picFirstName}
                setValue={(newValue) => {
                  setFieldValue("picFirstName", newValue);
                }}></Input.Field>
            </Form.ColGrow>
          </Form.Row>
        </Form.ColGrow>
      </Form.Row>
      <Form.Row>
        <Form.Col>電話番号</Form.Col>
        <Form.ColGrow>
          <Input.Field
            name="telephone"
            type="text"
            className="w-full"
            value={values.telephone}
            setValue={(newValue) => {
              setFieldValue("telephone", newValue);
            }}></Input.Field>
        </Form.ColGrow>
      </Form.Row>
      <Form.Row>
        <Form.Col>メールアドレス</Form.Col>
        <Form.ColGrow>
          <Input.Field
            name="email"
            type="text"
            className="w-full"
            value={values.email}
            setValue={(newValue) => {
              setFieldValue("email", newValue);
            }}></Input.Field>
        </Form.ColGrow>
      </Form.Row>
      <Form.Row>
        <Form.Col>住所</Form.Col>
        <Form.ColGrow className="space-y-2">
          <Form.Row>
            <Form.Col>
              <Input.Field name="postalCode" type="text" className="w-full" value={values.postalCode} placeholder="郵便番号" setValue={handlePostalCodeChange} />
            </Form.Col>
          </Form.Row>
          <Form.Row className="space-x-2">
            <Form.ColGrow>
              <Input.Field
                name="prefecture"
                type="text"
                className="w-full"
                value={values.prefecture}
                placeholder="県"
                setValue={(newValue) => {
                  setFieldValue("prefecture", newValue);
                }}
              />
            </Form.ColGrow>
            <Form.ColGrow>
              <Input.Field
                name="city"
                type="text"
                className="w-full"
                placeholder="市"
                value={values.city}
                setValue={(newValue) => {
                  setFieldValue("city", newValue);
                }}
              />
            </Form.ColGrow>
            <Form.ColGrow>
              <Input.Field
                name="street"
                type="text"
                className="w-full"
                placeholder="街"
                value={values.street}
                setValue={(newValue) => {
                  setFieldValue("street", newValue);
                }}
              />
            </Form.ColGrow>
            <Form.ColGrow>
              <Input.Field
                name="building"
                type="text"
                className="w-full"
                placeholder="住所"
                value={values.building}
                setValue={(newValue) => {
                  setFieldValue("building", newValue);
                }}
              />
            </Form.ColGrow>
          </Form.Row>
        </Form.ColGrow>
      </Form.Row>
      <Form.Row>
        <Form.Col>Niita契約</Form.Col>
        <Form.ColGrow>
          <FormControlLabel
            control={
              <Switch
                checked={!!values.niitaContract}
                onChange={(e) => {
                  setFieldValue("niitaContract", e.target.checked);
                }}
                name="niitaContract"
              />
            }
            label={values.niitaContract ? "あり" : "なし"}
          />
        </Form.ColGrow>
      </Form.Row>
    </div>
  );
}
export default SalonArtistForm;
